import Vue from 'vue'

// axios
import axios from 'axios'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

// Global response interceptor on the raw axios singleton (not axiosIns):
// every view in this app does `import axios from 'axios'` directly rather
// than importing this instance, so this is the only place that reaches
// every existing call site.
//
// Root cause this closes: 150+ write calls (axios.post/put/delete) across
// the app use only `.then()` with no `.catch()` and no surrounding
// try/catch, so on any failure (permission 403, validation 400, network
// error, 500) the promise rejects with nobody listening and the UI looks
// like the button did nothing - see the item-stocks min-stock bug report
// (2026-08-20) for the concrete case this was found from. Callers that
// already have their own `.catch()` (401 redirects, custom messages) still
// run afterwards - this only guarantees a visible toast where before there
// was silence.
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response ? error.response.status : null

    if (status === 401) {
      // Session expired / invalid token - some call sites already redirect
      // on this individually; make it universal so a 401 hit through any
      // of the unhandled call sites above still takes the user back to
      // login instead of doing nothing.
      router.push({ name: 'auth-login' }).catch(() => {})
    } else {
      const data = error.response && error.response.data
      const message = (data && (data.message || (typeof data === 'string' && data))) || error.message || 'Something went wrong'

      Vue.prototype.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }

    return Promise.reject(error)
  },
)

export default axiosIns
